import { MirinaeSelection } from "../../utils/MirinaeSelection.js";

/**
 * Mirinae Floating Toolbar (Shared)
 * 
 * Provides "Medium-like" floating controls for Rich Text Editing.
 * Appears when user selects text in a target container (default: .rich-text).
 */
export class MirinaeToolbar {
    constructor(selector = '.rich-text') {
        this.el = null;
        this.visible = false;
        this.currentRange = null;
        this.targetSelector = selector;
        // console.log('[MirinaeToolbar] Initialized with selector:', selector);

        // [FIX] Defer Init to ensure Body exists
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        if (this.initialized) return; // [FIX] Prevent duplicate initialization
        this.createDOM();
        this.bindEvents();
        this.initialized = true;
        console.log('[MirinaeToolbar] Initialized and events bound');
    }

    createDOM() {
        const existing = document.getElementById('mirinae-global-toolbar');
        if (existing) {
            this.el = existing;
            return;
        }

        const div = document.createElement('div');
        div.id = 'mirinae-global-toolbar';
        div.className = 'mirinae-floating-toolbar hidden';
        div.innerHTML = `
            <div class="mirinae-toolbar-actions">
                <button type="button" data-cmd="bold" class="mirinae-tool-btn" title="굵게 (Bold)">
                    <span class="material-symbols-outlined">format_bold</span>
                </button>
                <button type="button" data-cmd="italic" class="mirinae-tool-btn" title="기울임 (Italic)">
                    <span class="material-symbols-outlined">format_italic</span>
                </button>
                <div class="mirinae-tool-separator"></div>
                <button type="button" data-cmd="foreColor" data-val="#ef4444" class="mirinae-tool-btn text-red-500" title="강조 (Red)">
                    <span class="material-symbols-outlined" style="color: #ef4444;">format_color_text</span>
                </button>
                 <button type="button" data-cmd="foreColor" data-val="#3b82f6" class="mirinae-tool-btn text-blue-500" title="강조 (Blue)">
                    <span class="material-symbols-outlined" style="color: #3b82f6;">format_color_text</span>
                </button>
            </div>
            <div class="mirinae-toolbar-arrow"></div>
        `;
        document.body.appendChild(div);
        this.el = div;
        console.log('[MirinaeToolbar] DOM created and appended to body');
    }

    bindEvents() {
        if (!this.el) this.el = document.getElementById('mirinae-global-toolbar');

        // Global Selection Listener
        document.addEventListener('selectionchange', () => this.onSelectionChange());

        // Toolbar Button Clicks
        this.el.addEventListener('mousedown', (e) => {
            // Prevent loss of focus from editor
            e.preventDefault();
        });

        this.el.addEventListener('click', (e) => {
            const btn = e.target.closest('button');
            if (!btn) return;

            const command = btn.dataset.cmd;
            const value = btn.dataset.val;

            this.execute(command, value);
        });
    }

    onSelectionChange() {
        const selection = window.getSelection();

        // 1. Valid Check: Is text selected?
        if (!selection || selection.isCollapsed) {
            this.hide();
            return;
        }

        // 2. Scope Check: Is it inside our target editor?
        const range = selection.getRangeAt(0);
        const container = range.commonAncestorContainer;
        // Use configured selector
        const editorBlock = (container.nodeType === 3 ? container.parentNode : container).closest(this.targetSelector);

        if (!editorBlock) {
            // console.log('[MirinaeToolbar] Selection outside target editor');
            this.hide();
            return;
        }

        // 3. Update Position
        this.currentRange = range;
        console.log('[MirinaeToolbar] Showing toolbar', range);
        this.show(range);
    }

    show(range) {
        if (!this.el) {
            console.error('[MirinaeToolbar] Toolbar element not found!');
            this.createDOM(); // Try to recreate if missing
            if (!this.el) return;
        }

        const rect = range.getBoundingClientRect();

        // Calculate Position (Centered above selection)
        // [FIX] Use Fixed Position logic (No Scroll Y needed)
        const toolbarRect = this.el.getBoundingClientRect();
        const top = rect.top - toolbarRect.height - 10; // 10px spacing above selection
        const left = rect.left + (rect.width / 2) - (toolbarRect.width / 2);

        this.el.style.top = `${top}px`;
        this.el.style.left = `${left}px`;

        if (!this.visible) {
            this.el.classList.remove('hidden');
            this.el.classList.add('visible');
            this.visible = true;
        }
    }

    hide() {
        if (this.visible) {
            this.el.classList.remove('visible');
            this.el.classList.add('hidden');
            this.visible = false;
        }
    }

    execute(command, value) {
        // Ensure the editor still has focus or restore range
        // Since we blocked mousedown default, focus should be conserved.
        MirinaeSelection.applyStyle(command, value);
    }
}

// Default export as class for manual instantiation, or singleton usage
export const mirinaeToolbar = new MirinaeToolbar();
